<template>
  <v-container fluid tag="section" class="text_google login-page">
    <v-row justify="center" class="mt-6 mb-2">
      <v-col cols="12" md="8" class="text-center">
        <v-avatar size="72" class="mb-3">
          <v-img src="/ovec.png" alt="OVEC" contain></v-img>
        </v-avatar>
        <h1 class="brand-title">ระบบบริหารงานบุคคล สอศ.</h1>
        <p class="brand-subtitle mb-0">
          เลือกประเภทผู้ใช้งานด้านล่างเพื่อเข้าสู่ระบบ
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="10">
        <v-row>
          <v-col cols="12" md="6"><Loginuser /></v-col>
          <v-col cols="12" md="6"><LoginCollege /></v-col>
          <v-col cols="12" md="6"><Loginuser_gov /></v-col>
          <v-col cols="12" md="6"><LoginuserEtc /></v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row justify="center" class="mt-2 mb-8">
      <v-col cols="12" md="10">
        <v-alert
          border="left"
          colored-border
          color="success"
          elevation="2"
          class="manual-banner"
        >
          <div class="d-flex align-center flex-wrap">
            <div class="flex-grow-1">
              <strong>รหัสผ่านของครู/บุคลากร คือวันเดือนปีเกิด</strong> (เช่น 8/8/2531 ไม่ต้องระบุ 0 นำหน้า)
              — แนะนำให้เปลี่ยนรหัสผ่านทันทีหลังเข้าสู่ระบบครั้งแรก
            </div>
            <v-btn color="success" to="/news" rounded class="ml-auto mt-2 mt-sm-0">
              <v-icon left small>mdi-book-open-page-variant</v-icon>คู่มือการใช้งาน
            </v-btn>
          </div>
        </v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import LoginCollege from "../components/core/loginCollege.vue";
import Loginuser from "../components/core/loginuser.vue";
import Loginuser_gov from "../components/core/loginuser_gov.vue";
import LoginuserEtc from "../components/core/loginuserEtc.vue";

export default {
  components: {
    Loginuser,
    LoginCollege,
    LoginuserEtc,
    Loginuser_gov
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit:wght@300&display=swap");
</style>

<style scoped>
.text_google {
  font-family: "Kanit", sans-serif;
}

.login-page {
  min-height: 100vh;
}

.brand-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2d3748;
  margin-bottom: 4px;
}

.brand-subtitle {
  color: #718096;
  font-size: 1.05rem;
}

.manual-banner {
  border-radius: 12px;
}

@media (max-width: 600px) {
  .brand-title {
    font-size: 1.5rem;
  }
}
</style>
